import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import urls from '../../constants/urls.js';
import MailingListService from '../../services/mailingListService.js';

class MailingList extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = 
        { 
            email: '',
            color: '#555',
            defaultColor: '#555',
        };
        this.handleChange = this.handleChange.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.emailFocused = this.emailFocused.bind(this);
    }

    handleChange(event) {
        this.setState({email: event.target.value});
    }

    subscribe(event) {
        event.preventDefault();
        MailingListService.subscribe(this.state.email, this.props.articleType)
            .then(data => {
                this.setState({email: 'Thanks!', color: 'green'});
            })
            .catch(error => {
                this.setState({color: 'red'});
            });
    }

    emailFocused() {
        if(this.state.email == 'Thanks!') {
            this.setState({email: ''});
        }
        this.setState({color: this.state.defaultColor});
    }

    render() {
        return (
            <div id="mailingListHolder">
                <div className="form form-nletter">
                    <input className="form-control inputfield transition" id="Email" name="Email" value={this.state.email} onChange={this.handleChange} onFocus={this.emailFocused} placeholder="Your e-mail address" type="text" style={{color: this.state.color}} />
                    <a id="lnkAddToMailingList" className="btn-add transition" href="#" onClick={this.subscribe}>+</a>
                </div>
                {
                    !this.props.articleType ?
                        <p><strong>LoudUp your inbox?</strong> Sign up for email updates</p>
                        : null
                }
            </div>
        );
    }
}

MailingList.propTypes = {
    articleType: PropTypes.string
};

export default MailingList;